import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { NewApiUserService } from '../new-api-user/new-api-user.service';
import { SelectClientService } from '@brunsker/libs/portal-do-vendedor/utils/portal-vendedor-api';

@Injectable({
  providedIn: 'root'
})
export class VendedorSelectService{
  vendedorSelectUse$$ = new BehaviorSubject<number>(0);

  constructor(
    private readonly newApiUserService: NewApiUserService,
    private readonly selectClientService: SelectClientService
  ){
    this.selectClientService.hasClient$$.subscribe( value => value ? '' : this.vendedorSelectUse$$.next(0) )
  }

  vendedorActiv(){
    const vendSession = this.selectClientService.getCliente()?.vendedor;
    const validSession =  this.vendedorSelectUse$$.value != 0 ? this.vendedorSelectUse$$.value : vendSession;
    const vendedor = validSession ?? this.vendedorSelectUse$$.value;
    const funci =
      !!vendedor ? vendedor :
      this.newApiUserService.currentUser()?.idVendedor;

    return funci;
  }
}
